import { h } from 'preact';
import style from "./style.css";
import cx from 'classnames';

const HowItWorks = () => (
    <div className={cx(style.howItWorks, 'flex', 'flex-col')}>
        <div className={cx(style.header, 'flex', 'flex-col', 'items-center', 'content-center')}>
            <img src={'/assets/howItWorks/howItWorksIcon.png'}/>
            HOW IT WORKS
        </div>
        <div className={cx(style.howItWorksImages, 'flex', 'flex-row', 'justify-between', 'self-center')}>
            <WorksBox position='01' title='PICK' text='a player to perform well' imgUrl='/assets/howItWorks/how_it_works_1.png' />
            <WorksBox position='02' title='CHOOSE' text='points he will get and stake' imgUrl='/assets/howItWorks/how_it_works_2.png' />
            <WorksBox position='03' title='COLLECT' text='if he hits or exceeds your target points at the end of the game' imgUrl='/assets/howItWorks/how_it_works_3.png' />
        </div>
        <div className={cx(style.features, 'flex', 'flex-row')}>
            <div className={style.imgBox}></div>
            <div className={cx(style.grayBckHax, 'flex', 'flex-col')}>
                <div className={cx(style.subBox, 'flex', 'flex-col', 'self-end')}>
                    <div className={'labelBoxLine'} style={{marginTop: '90px'}}></div>
                    <div className={'subTitleText'} style={{marginBottom: '20px'}}>
                        KEY FEATURES
                    </div>
                    <div className={cx(style.featurePoints, 'flex', 'flex-row', 'flex-1', 'flex-wrap', 'justify-between')}>
                        <FeaturePoint imgUrl='/assets/howItWorks/icon_cashout.png' title='CASH OUT' text='An easy way to guarantee a profit regardless of the final result or cut your losses at any time.' />
                        <FeaturePoint imgUrl='/assets/howItWorks/pointsIcon.png' title='LIVE POINTS' text='Keep track of how your selected players are scoring points in real time.' />
                        <FeaturePoint imgUrl='/assets/howItWorks/commentsIcon.png' title='LIVE COMMENTARY' text='Our commentary feature translates data sent from OPTA into text, allowing people to follow both the game and players performance.' />
                        <FeaturePoint imgUrl='/assets/howItWorks/profileIcon.png' title='PROFILE' text='Here you can store and review players’ past performances, how they scored their points in previous games, and when they are playing next.' />
                        <FeaturePoint imgUrl='/assets/howItWorks/favouritesIcon.png' title='FAVOURITES' text='By clicking the star by a player, you can add them to your favourites.' />
                    </div>
                </div>
            </div>
        </div>
    </div>
);


function WorksBox(props) {
    return <div className={cx('flex', 'flex-col', 'justify-center', 'items-center')}>
        <div className={cx('flex')}>&nbsp;</div>
        <div className={cx('flex')} style={{textAlign: 'center'}}>{props.title}</div>
        <div className={cx('flex')} style={{textAlign: 'center', padding: '10px'}}>{props.text}</div>
        <img className={cx('flex')} src={props.imgUrl}/>
    </div>;
}

function FeaturePoint(props) {
    return <div className={cx(style.featurePoint, 'flex', 'flex-row', 'flex-1')}>
        <div className={cx(style.featurePointIcon, 'flex')} style={{backgroundImage: 'url('+props.imgUrl+')'}}></div>
        <div className={cx('flex', 'flex-col', 'justify-center')}>
            <div className={style.titleText}>{props.title}</div>
            <div className={style.featureSubPoint}>{props.text}</div>
        </div>
    </div>;
}

export default HowItWorks;


// WEBPACK FOOTER //
// ./components/HowItWorks/index.jsx